// Components==============
import Checkbox from 'components/UI/CheckboxOld';
import { motion } from 'framer-motion';
import React from 'react';
import './index.module.scss';
// =========================

export function TextInput({
    type = 'text',
    label,
    name,
    value,
    onChange,
    required = true,
    placeholder,
    noMargin,
}) {
    return (
        <div>
            {label && <label>{label}</label>}
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                styleName={`text-input ${noMargin ? 'no-margin' : ''}`}
                required={required}
                placeholder={placeholder}
            />
        </div>
    );
}

export function TextAreaInput({
    label,
    name,
    value,
    onChange,
    required = true,
    placeholder,
}) {
    return (
        <div>
            <label>{label}</label>
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                styleName="text-area-input"
                required={required}
                placeholder={placeholder}
            />
        </div>
    );
}

export function Options({ options, label, setSelected, selected }) {
    function handleClick(option) {
        const exists = selected.find((current) => current === option);

        if (!exists)
            return setSelected((prev) => ({
                ...prev,
                to: [...prev.to, option],
            }));

        setSelected((prev) => ({
            ...prev,
            to: prev.to.filter((current) => current !== option),
        }));
    }

    return (
        <div styleName="options">
            <label>{label}</label>
            <div styleName="wrapper">
                {options.map((option) => {
                    const isSelected = selected.find((e) => e === option);

                    return (
                        <motion.div
                            key={option}
                            styleName="option"
                            onClick={() => handleClick(option)}
                        >
                            <Checkbox
                                isSelected={isSelected}
                                background="#F1F0EA"
                            />
                            <motion.p
                                animate={{
                                    color: isSelected ? '#1e265c' : '#707070',
                                }}
                                initial={{ color: '#707070' }}
                                whileHover={{ x: 2 }}
                            >
                                {option}
                            </motion.p>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
}
